const toDateOnlyUtc = (value) => {
  if (!value) return null;

  const raw = String(value).slice(0, 10);
  const parsed = new Date(`${raw}T00:00:00Z`);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const startOfTodayUtc = (now = new Date()) => {
  return new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()),
  );
};

const isCancelledReservation = (reservation) => {
  return String(reservation?.category || "").toUpperCase() === "CXL";
};

const isCheckedInReservation = (reservation) => {
  if (reservation?.checked_in === true || reservation?.checked_in === 1) {
    return true;
  }

  return false;
};

const spansToday = (reservation, today) => {
  const checkIn = toDateOnlyUtc(reservation?.check_in);
  const checkOut = toDateOnlyUtc(reservation?.check_out);

  if (!checkIn || !checkOut) {
    return false;
  }

  return checkIn.getTime() <= today.getTime() && checkOut.getTime() >= today.getTime();
};

const getReservationRank = (reservation, today) => {
  if (isCancelledReservation(reservation)) return 4;
  if (isCheckedInReservation(reservation)) return 0;
  if (spansToday(reservation, today)) return 1;

  const checkIn = toDateOnlyUtc(reservation?.check_in);
  if (checkIn && checkIn.getTime() > today.getTime()) return 2;

  return 3;
};

const compareDateAsc = (left, right, field) => {
  const leftTime = toDateOnlyUtc(left?.[field])?.getTime() ?? Number.POSITIVE_INFINITY;
  const rightTime = toDateOnlyUtc(right?.[field])?.getTime() ?? Number.POSITIVE_INFINITY;
  return leftTime - rightTime;
};

const compareDateDesc = (left, right, field) => {
  const leftTime = toDateOnlyUtc(left?.[field])?.getTime() ?? Number.NEGATIVE_INFINITY;
  const rightTime = toDateOnlyUtc(right?.[field])?.getTime() ?? Number.NEGATIVE_INFINITY;
  return rightTime - leftTime;
};

export const sortReservationsByPriority = (reservations = [], now = new Date()) => {
  const today = startOfTodayUtc(now);

  return [...reservations].sort((left, right) => {
    const rankDiff = getReservationRank(left, today) - getReservationRank(right, today);
    if (rankDiff !== 0) {
      return rankDiff;
    }

    const rank = getReservationRank(left, today);
    if (rank <= 1) {
      const byCheckIn = compareDateAsc(left, right, "check_in");
      if (byCheckIn !== 0) return byCheckIn;
      return compareDateAsc(left, right, "check_out");
    }

    if (rank === 2) {
      const byCheckIn = compareDateAsc(left, right, "check_in");
      if (byCheckIn !== 0) return byCheckIn;
      return compareDateAsc(left, right, "check_out");
    }

    const byCheckOut = compareDateDesc(left, right, "check_out");
    if (byCheckOut !== 0) return byCheckOut;

    return compareDateDesc(left, right, "check_in");
  });
};

export const selectPreferredReservation = (reservations = [], now = new Date()) => {
  return sortReservationsByPriority(reservations, now)[0] || null;
};